import { useVeriModel, UseVeriModelOptions } from "../../useVeriModel";
import { UserModel } from "../../../models";
import apiUserModel from "./apiUserModel";

export default function useUserModel(opts?: UseVeriModelOptions<UserModel>) {
  return useVeriModel(apiUserModel, opts);
}
